import { Text } from "react_reusable_components";
import { formatDate, formatMonth, getLocalizedMessage } from "../../UtilityFunctions/utils";
import Styles from "./AuditListingContainer.module.scss";
import {
  AUDIT_STATUSES,
  OPTIONS_MAPPING,
  plannedMonth,
  userRole,
} from "../../constants";

export const columns = (intl, responsive, currentRoleId, sortedInfo) =>
  [
    {
      dataIndex: "plannedMonth",
      key: "name",
      title: (
        <Text className={Styles["header-text"]}>
          {getLocalizedMessage(intl, "auditListing.plannedMonth")}
        </Text>
      ),
      render: (text, record) => (
        <Text type="secondary" className={Styles["text-style"]}>
          {plannedMonth
            .find(({ value }) => value === Number(text))
            ?.name?.substring(0, 3)}{" "}
          {record?.plannedYear ? `${record?.plannedYear}`?.slice(-2) : ""}
        </Text>
      ),
    },
    {
      dataIndex: "auditType",
      key: "auditType",
      title: (
        <Text className={Styles["header-text"]}>
          {getLocalizedMessage(intl, "auditListing.auditType")}
        </Text>
      ),
      render: (text) => (
        <Text type="secondary" className={Styles["text-style"]}>
          {text || "-"}
        </Text>
      ),
    },
    currentRoleId === userRole.ADMIN &&
      responsive.isMd && {
        dataIndex: "countryName",
        key: "countryName",
        title: (
          <Text className={Styles["header-text"]}>
            {getLocalizedMessage(intl, "auditListing.country")}
          </Text>
        ),
        render: (text) => (
          <Text
            type="secondary"
            className={`${Styles["text-style"]} ${Styles["no-capitalize"]} ${Styles["ellipsis-style"]}`}
          >
            {text}
          </Text>
        ),
      },
    {
      dataIndex: "dnsd",
      key: "dnsd",
      title: (
        <Text className={Styles["header-text"]}>
          {getLocalizedMessage(intl, "auditListing.DNSDName")}{" "}
        </Text>
      ),
      render: (text) => (
        <Text type="secondary" className={Styles["text-style"]}>
          {text?.name}
        </Text>
      ),
    },
    {
      dataIndex: "dnsd",
      key: "globalId",
      title: (
        <Text className={Styles["header-text"]}>
          {getLocalizedMessage(intl, "auditListing.globalId")}{" "}
        </Text>
      ),
      render: (text) => (
        <Text type="secondary" className={Styles["text-style"]}>
          {text?.globalId}
        </Text>
      ),
    },
    currentRoleId !== userRole.TM &&
      responsive.isMd && {
        dataIndex: "tm",
        key: "tm",
        title: (
          <Text className={Styles["header-text"]}>
            {getLocalizedMessage(intl, "auditListing.tm")}{" "}
          </Text>
        ),
        render: (text) => (
          <Text type="secondary" className={Styles["text-style"]}>
            {text?.name || "-"}
          </Text>
        ),
      },
    (responsive.isMd || responsive.isSm) && {
      dataIndex: "productcategory",
      key: "productcategory",
      title: (
        <Text className={Styles["header-text"]}>
          {getLocalizedMessage(intl, "auditListing.productCategory")}
        </Text>
      ),
      render: (productcategory) => (
        <Text type="secondary" className={Styles["text-style"]}>
          {productcategory?.name || "-"}
        </Text>
      ),
    },
    (responsive.isMd || responsive.isSm) && {
      dataIndex: "productsubcategory",
      key: "productsubcategory",
      title: (
        <Text className={Styles["header-text"]}>
          {getLocalizedMessage(intl, "auditListing.productSubCategory")}
        </Text>
      ),
      render: (productSubCategory) => (
        <Text type="secondary" className={Styles["text-style"]}>
          {productSubCategory?.name || "-"}
        </Text>
      ),
    },
    responsive.isMd && {
      dataIndex: "auditMedium",
      key: "auditMedium",
      title: (
        <Text className={Styles["header-text"]}>
          {getLocalizedMessage(intl, "auditListing.currentAuditMode")}{" "}
        </Text>
      ),
      render: (auditMedium) => (
        <Text type="secondary" className={Styles["text-style"]}>
          {auditMedium || "-"}
        </Text>
      ),
    },
    // responsive.isMd && {
    //   dataIndex: "startDate",
    //   key: "startDate",
    //   sorter: true,
    //   sortOrder: sortedInfo?.columnKey === "startDate" && sortedInfo?.order,
    //   title: (
    //     <Text className={Styles["header-text"]}>
    //       {getLocalizedMessage(intl, "auditListing.startDate")}
    //     </Text>
    //   ),
    //   render: (startDate) => (
    //     <Text
    //       type="secondary"
    //       className={`${Styles["text-style"]} ${Styles["ellipsis-style"]}`}
    //     >
    //       {startDate ? formatDate(startDate, intl) : "-"}
    //     </Text>
    //   ),
    // }, Uncomment to reopen start date
    responsive.isMd && {
      dataIndex: "endDate",
      key: "endDate",
     title: (
        <Text className={Styles["header-text"]}>
          {getLocalizedMessage(intl, "auditListing.endDate")}
        </Text>
      ),
      render: (endDate) => (
        <Text
          type="secondary"
          className={`${Styles["text-style"]} ${Styles["ellipsis-style"]}`}
        >
          {endDate ? formatMonth(endDate, intl) : "-"}
        </Text>
      ),
    },
    {
      dataIndex: "status",
      key: "status",
      title: (
        <Text className={Styles["header-text"]}>
          {getLocalizedMessage(intl, "auditListing.auditStatus")}
        </Text>
      ),
      render: (status) => (
        <Text type="secondary" className={Styles["text-style"]}>
          {status || "-"}
        </Text>
      ),
    },
    responsive.isMd &&
      currentRoleId === userRole.TM && {
        dataIndex: "reAuditDueDate",
        key: "reAuditDueDate",
        title: (
          <Text className={Styles["header-text"]}>
            {getLocalizedMessage(intl, "auditListing.reAuditDueDate")}
          </Text>
        ),
        render: (text) => (
          <Text type="secondary" className={Styles["text-style"]}>
            {text ? formatDate(text, intl) : "-"}
          </Text>
        ),
      },
  ].filter((item) => item);

export function createAction(label, src, action) {
  return { label, icon: renderIcon(src), action };
}

export function renderIcon(src) {
  return <img alt="icon" src={src} className={Styles["icon-style"]} />;
}

export function getTMActions(
  record,
  intl,
  {
    changeStatus,
    startAudit,
    setAuditType,
    continueAudit,
    sendForReAudit,
    sendLinkToDnsd,
    previewAudit,
    copyLink,
    markAuditComplete,
    editAudit,
    sendReportToSD,
    downloadReport,
    sendAuditPdfToSD,
  }
) {
  let defaultOptions = [
    createAction(
      getLocalizedMessage(intl, "auditListing.action.markOnHold"),
      "/icons/stop 1.svg",
      (recordData, { changeStatus: changeAuditStatus }) =>
        changeAuditStatus(recordData)
    ),
    createAction(
      getLocalizedMessage(intl, "auditListing.action.startAudit"),
      "/icons/start.svg",
      (recordData, { startAudit: initiateAudit }) => initiateAudit(recordData)
    ),
    createAction(
      getLocalizedMessage(intl, "auditListing.action.setAuditType"),
      "/icons/reply_all.svg",
      (recordData, { setAuditType: putAuditType }) => putAuditType(recordData)
    ),
  ];

  let actionsArr =
    record.status === AUDIT_STATUSES.ON_HOLD
      ? [
          createAction(
            getLocalizedMessage(intl, "auditListing.action.markPending"),
            "/icons/pending_actions.svg",
            (recordData, { changeStatus: changeAuditStatus }) =>
              changeAuditStatus(recordData)
          ),
        ]
      : defaultOptions;
  if (record.auditMedium in OPTIONS_MAPPING(intl)) {
    actionsArr =
      OPTIONS_MAPPING(intl)[record.auditMedium][record.status] ||
      defaultOptions;
  }

  return actionsArr?.map?.((action) => ({
    ...action,
    action: () =>
      action.action(record, {
        changeStatus,
        startAudit,
        setAuditType,
        continueAudit,
        sendForReAudit,
        sendLinkToDnsd,
        previewAudit,
        copyLink,
        markAuditComplete,
        editAudit,
        sendReportToSD,
        downloadReport,
        sendAuditPdfToSD,
      }), // add action function with records and function
  }));
}
